import { translateBase } from 'data/translation';

const useTranslate = (group, tehnicalText, language) => {
  const text = translateBase.translate[group][tehnicalText];

  return text[language] === '' ? text.uk : text[language];
};

export default useTranslate;
